import { AsyncPipe } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    computed,
    effect,
    forwardRef,
    inject,
    model,
    ModelSignal,
} from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Title } from '@models/title';
import { TitlesService } from 'app/core/titles/titles.service';
import { FormLabelPipe } from 'app/shared/pipes/form-label.pipe';

@Component({
    selector: 'app-title-selector',
    templateUrl: './title-selector.component.html',
    styleUrls: ['./title-selector.component.scss'],
    imports: [AsyncPipe, FormLabelPipe, FormsModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TitleSelectorComponent),
            multi: true,
        },
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TitleSelectorComponent implements ControlValueAccessor {
    protected selectedTitle: ModelSignal<Title | null> = model<Title | null>(null);
    private titlesService: TitlesService = inject<TitlesService>(TitlesService);
    protected titles$ = computed(() => this.titlesService.naturalPersonTitles$);

    private onChange: (val: Title | null) => void;
    protected onTouch: () => void;

    public constructor() {
        let initialChange: boolean = true;
        effect(() => {
            const selectedTitle = this.selectedTitle();
            if (typeof this.onChange === 'function') {
                this.onChange(selectedTitle);
            }
            if (initialChange) {
                initialChange = false;
            } else if (typeof this.onTouch === 'function') {
                this.onTouch();
            }
        });
    }

    public writeValue(value: Title | null): void {
        this.selectedTitle.set(value);
    }

    public registerOnChange(fn: (val: Title | null) => void): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: () => void): void {
        this.onTouch = fn;
    }
}
